const NAME = "RECOGNITION_PLANS_ASSIGNMENT";

export default NAME;
